import { render } from "./AudiogramChart.vue?vue&type=template&id=183b860d&scoped=true"
import script from "./AudiogramChart.vue?vue&type=script&lang=js"
export * from "./AudiogramChart.vue?vue&type=script&lang=js"

import "./AudiogramChart.vue?vue&type=style&index=0&id=183b860d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-183b860d"]])

export default __exports__